import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
import { AppProvider } from './domain/AppContext';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('O elemento raiz da aplicação não foi encontrado.');

try {
  createRoot(root).render(
    <StrictMode>
      <HashRouter>
        <AppProvider>
          <App />
        </AppProvider>
      </HashRouter>
    </StrictMode>,
  );
} catch (error) {
  root.innerHTML = '<main class="app-bootstrap" role="alert"><h1>Oficina Sapiens</h1><p>Não foi possível iniciar a interface. Recarregue a página.</p></main>';
  console.error('Falha ao montar a aplicação React', error);
}
